import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';

import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VehicleMakeService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('vehicle-make', http, authentication);
  }


}